import { FC } from 'react';
import { useDidMount } from '@material-bank/ds-utils';
import { Stack } from '@material-bank/mb-uikit/components/Stack';
import ReactDOM from 'react-dom/client';

import { SignInFlowController } from './components/SignInFlowController';
import { SignInGlobalStyles } from './components/SignInGlobalStyles';
import * as styles from './styles';

import { useDialogs } from '../../components/DialogsController';
import { AppProviders } from '../../components/providers/AppProviders';

export const SignInPage: FC = () => {
  const { openDialog } = useDialogs();

  useDidMount(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const viewParam = searchParams.get('view');

    if (viewParam === 'reset-forgotten-password') {
      openDialog('resetPassword', {
        customerId: searchParams.get('id') || '',
        token: searchParams.get('token') || '',
      });
    }
  });

  return (
    <Stack sx={styles.root}>
      <SignInFlowController />
    </Stack>
  );
};

const rootElement = document.getElementById('sign-in-page-root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <AppProviders>
      <SignInGlobalStyles />
      <SignInPage />
    </AppProviders>,
  );
}
